import { VehicleDetailImagesType } from "../enums/vehicle-images.enums";
import { TImages } from "./vehicle.interface";

export interface VehicleDimensionsData {
  lengthMm: number;
  widthMm: number;
  heightMm: number;
  wheelbaseMm?: number;
  seatHeightMm?: number;
  loadCapacityKg?: number;
}

export interface VehicleDetailImage extends TImages {
  imageType: VehicleDetailImagesType;
  alternativeText: string;
}

export interface vehicleDetailData {
  brand: string;
  model: string;
  cc: number;
  years: number[];
  engineType: string;
  maxSpeedKmh?: number;
  maxPower: string;
  maxTorque?: string;
  fuelEfficiencyKml?: number;
  fuelSystem?: string;
  fuelCapacityLiters: number;
  transmissionType: string;
  transmissionSpeeds: number;
  coolingSystem: string;
  frontSuspension: string;
  rearSuspension: string;
  frontBrakes: string;
  rearBrakes: string;
  frontTire: string;
  rearTire: string;
  dimensions: VehicleDimensionsData;
  images: VehicleDetailImage[];
}

const MIN_VEHICLE_DETAIL_IMAGES = 3;

const isDefinedNumber = (value: unknown): value is number =>
  typeof value === "number" && !Number.isNaN(value);

export const isVehicleDetailComplete = (details?: vehicleDetailData | null): boolean => {
  if (!details) return false;

  const requiredStrings = [
    details.engineType,
    details.maxPower,
    details.maxTorque,
    details.fuelSystem,
    details.transmissionType,
    details.coolingSystem,
    details.frontSuspension,
    details.rearSuspension,
    details.frontBrakes,
    details.rearBrakes,
    details.frontTire,
    details.rearTire,
  ];
  if (requiredStrings.some((value) => !value)) return false;

  const requiredNumbers = [
    details.maxSpeedKmh,
    details.fuelEfficiencyKml,
    details.fuelCapacityLiters,
    details.transmissionSpeeds,
  ];
  if (requiredNumbers.some((value) => !isDefinedNumber(value))) return false;

  const { dimensions } = details;
  const requiredDimensions = dimensions
    ? [dimensions.lengthMm, dimensions.widthMm, dimensions.heightMm]
    : [];
  if (!dimensions || requiredDimensions.some((value) => !isDefinedNumber(value))) return false;

  if (!details.images || details.images.length < MIN_VEHICLE_DETAIL_IMAGES) return false;

  return true;
};
